export default "__VITE_ASSET__877ab539__"